<template>
  <div>
    <mu-raised-button
      label="Filters"
      primary
      @click.native="isModalShown = !isModalShown">
    </mu-raised-button>

    <mu-dialog
      class="scrollBox"
      :open="isModalShown"
      title="Refine your search"
      @close="isModalShown = false"
      scrollable>

      <div style="padding-top: 34px;">

        <div class="bottom">
          <div>Carbohydrate <span class="floatRight">{{model.carbs[0] + ' - ' + model.carbs[1]}}g</span></div>
          <vue-slider
            @drag-end="valuesChanged"
            :speed="0"
            :start-animation="false"
            v-bind="carbSlider"
            v-model="model.carbs">
          </vue-slider>
        </div>

        <div class="bottom">
          <div>Fat <span class="floatRight">{{model.fat[0] + ' - ' + model.fat[1]}}g</span></div>
          <vue-slider
            @drag-end="valuesChanged"
            :speed="0"
            :start-animation="false"
            v-bind="fatSlider"
            v-model="model.fat">
          </vue-slider>
        </div>

        <div class="bottom">
          <div>Calories <span class="floatRight">{{model.calories[0] + ' - ' +  model.calories[1]}}kcal</span></div>
          <vue-slider
            @drag-end="valuesChanged"
            :speed="0"
            :start-animation="false"
            v-bind="calorieSlider"
            v-model="model.calories">
          </vue-slider>
        </div>

        <div class="bottom">
          <div>Protein <span class="floatRight">{{model.protein[0] + ' - ' +  model.protein[1]}}g</span></div>
          <vue-slider
            @drag-end="valuesChanged"
            :speed="0"
            :start-animation="false"
            v-bind="proteinSlider"
            v-model="model.protein">
          </vue-slider>
        </div>

      </div>

      <mu-flat-button
        primary
        :label="$t('message.okText')"
        slot="actions"
        @click.native="isModalShown = false"
        />
    </mu-dialog>


  </div>
</template>

<script>
  import MuRaisedButton from "muse-ui/src/raisedButton/raisedButton";
  import vueSlider from 'vue-slider-component/src/vue2-slider.vue'

  export default {
    components: {MuRaisedButton, vueSlider},
    name: "meal-plan-filter-modal",
    data() {
      return {
        isModalShown: false,
        sliderOptions: {
          carbs: {
            min: 0,
            max: 500,
            trackColor: 'rgb(126, 211, 33)',
            backgroundColor: 'rgba(126, 211, 33, 0.3)'
          },
          fat: {
            min: 0,
            max: 500,
            trackColor: 'rgb(60, 177, 255)',
            backgroundColor: 'rgba(60, 177, 255, 0.3)'
          },
          calories: {
            min: 0,
            max: 3000,
            trackColor: 'rgb(80, 227, 194)',
            backgroundColor: 'rgba(80, 227, 194, 0.3)'
          },
          protein: {
            min: 0,
            max: 500,
            trackColor: 'rgb(255, 94, 7)',
            backgroundColor: 'rgba(255, 94, 7, 0.3)'
          }
        },
        model: {
          carbs: [0, 500],
          fat: [0, 500],
          calories: [0, 3000],
          protein: [0, 500],
          totaltime: [0, 200]
        }
      }
    },
    watch: {
      'model.carbs': function () {
        this.valuesChanged();
      },
      'model.fat': function () {
        this.valuesChanged();
      },
      'model.calories': function () {
        this.valuesChanged();
      },
      'model.protein': function () {
        this.valuesChanged();
      }
    },
    mounted() {
      this.valuesChanged();
    },
    methods: {
      valuesChanged() {
        let self = this;
        self.$emit('change', {
          carbgte: self.model.carbs[0],
          carblte: self.model.carbs[1],
          fatgte: self.model.fat[0],
          fatlte: self.model.fat[1],
          caloriesgte: self.model.calories[0],
          calorieslte: self.model.calories[1],
          proteingte: self.model.protein[0],
          proteinlte: self.model.protein[1]
        })
      },
      assignSliderOptions(key) {
        let self = this;
        let sliderSettings = self.sliderSettings;
        let sliderOptions = {
          value: [self.sliderOptions[key].min, self.sliderOptions[key].max],
          min: self.sliderOptions[key].min,
          max: self.sliderOptions[key].max,
          tooltip: false,
          bgStyle: {
            backgroundColor: self.sliderOptions[key].backgroundColor
          },
          processStyle: {
            backgroundColor: self.sliderOptions[key].trackColor
          }
        };
        return self.mergeSliderOptions(sliderSettings, sliderOptions)
      },
      mergeSliderOptions(sliderSettings, sliderValidation) {
        return Object.assign({}, sliderSettings, sliderValidation);
      }
    },
    computed: {
      carbSlider() {
        let self = this;
        return self.assignSliderOptions('carbs')
      },
      fatSlider() {
        return this.assignSliderOptions('fat')
      },
      calorieSlider() {
        return this.assignSliderOptions('calories')
      },
      proteinSlider() {
        return this.assignSliderOptions('protein')
      }
    }
  }
</script>

<style lang="less">
  .mu-dialog {
    .scrollable {
      height: initial !important;

    }
  }
</style>



// WEBPACK FOOTER //
// meal-plan-filter-modal.vue?c6ad60cc